import { ProductSideSheet } from 'modules/products/components/ProductSideSheet';
import { TProducts } from 'modules/products/context';
import {
  TQualification,
  TQualificationWithStatusAndProduct,
} from 'modules/customer/interfaces/qualifications';
import { EQualificationRole } from 'modules/products/context/QualificationsProvider/qualifications.interfaces';
import PersonContent from '../PersonContent/PersonContent';
import RegisterContent from '../RegisterContent/RegisterContent';

export interface IQualificationsSideSheetProps {
  handleClose: () => void;
  isOpen: boolean;
  qualification?: TQualificationWithStatusAndProduct | undefined;
  productInfo?: TProducts | undefined;
  borrowerQualificationData?: TQualification;
}

const QualificationsSideSheet = ({
  handleClose,
  isOpen,
  qualification,
  productInfo,
  borrowerQualificationData,
}: IQualificationsSideSheetProps) => {
  const onClose = () => {
    handleClose();
  };

  return (
    <ProductSideSheet
      open={isOpen}
      handleClose={onClose}
      title={
        (qualification?.role === EQualificationRole.EMPLOYER
          ? qualification?.employer?.legal_name
          : qualification?.borrower?.name) || ''
      }
    >
      <PersonContent
        borrowerQualificationData={borrowerQualificationData}
        selectedQualification={qualification}
      />
      <RegisterContent product={productInfo} />
    </ProductSideSheet>
  );
};

export default QualificationsSideSheet;
